export default Object.freeze({
    // apiBaseUrl: "http://15.206.82.38/api/v1/",
    // apiBaseUrl: "http://localhost:5000/api/v1/",
    // apiBaseUrl: "https://3yr8bxuy51.execute-api.ap-south-1.amazonaws.com/dev/api/v1/",
    //   apiBaseUrl: "https://renna-temp.lukojewel.dev/api/v1/",
    // apiBaseUrl: "https://app.zappit.software/dev/api/v1/",
    // apiBaseUrl: "https://app.zappit.software/api/v1/",
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "https://stg1.zappit.software/api/v1/",
    JWT_SECRET_KEY: import.meta.env.VITE_JWT_SECRET_KEY || "WdE6W4S5KAeFBLRDrWE5Ky4BS4MDmFKBFz6DZEe"
});